// extracted by mini-css-extract-plugin
module.exports = {"container":"_fI","modal_area":"_fJ","window":"_fK","icon_close":"_fL"};